import React, { FC, useEffect } from 'react';
import { AnalyticsSenderProvider, useAnalytics } from '@funtech-int/yango-shared';

import { EmptyContent } from '@/shared/components/EmptyContent/EmptyContent';
import { mainRoute } from '@/scenarios/home/routes';

import { useI18n } from '../../hooks/useI18n';
import { createAnalyticsEvents } from '../../lib/createAnalyticsEvents';
import { EmptySelectionError } from '../../lib/error';

import styles from './EmptySelection.module.css';

interface EmptySelectionProps {
    error: EmptySelectionError;
}

const EmptySelectionComponent: FC<EmptySelectionProps> = ({ error }) => {
    const i18n = useI18n();
    const analytics = useAnalytics(createAnalyticsEvents);

    useEffect(() => {
        analytics.error(error.key, error.title);
    }, [analytics, error]);

    return (
        <EmptyContent
            title={i18n('selection_empty_watch_later')}
            buttonText={i18n('selection_empty_watch_later_button')}
            location={mainRoute()}
            className={styles.root}
        />
    );
};

export const EmptySelection: FC<EmptySelectionProps> = ({ error }) => (
    <AnalyticsSenderProvider>
        <EmptySelectionComponent error={error} />
    </AnalyticsSenderProvider>
);
